let isCode=false

function setIsCode(a){
    isCode=a
}

function getIsCode(){
    return isCode
}

export {setIsCode,getIsCode}